import { withHTMLComponent } from '@updater/ui-custom-element';
import '@updater/ui-focus-out';

var styles = ":host {\n  display: block;\n\n  /* New stacking context */\n  position: relative;\n  z-index: 0;\n}\n\n::slotted(*) {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n::slotted(:not(:first-child)) {\n  /*\n    Move adjacent tiles up to overlap the border above\n    so we don't double up the borders.\n\n    Note: Should just be able to use -0.0625em; but IE / Edge\n    round 0.0625em to 0.06em. So, using calc as a workaround.\n  */\n  margin-top: -0.0625em;\n}\n\n::slotted(:not(:last-child):first-child) {\n  border-radius: 0.25em 0.25em 0 0;\n}\n\n::slotted(:not(:first-child):not(:last-child)) {\n  border-radius: 0;\n}\n\n::slotted(:not(:first-child):last-child) {\n  border-radius: 0 0 0.25em 0.25em;\n}\n\n::slotted(:hover) {\n  position: relative;\n  z-index: 1;\n}\n\n::slotted(.upd-focus) {\n  outline: none;\n  position: relative;\n  z-index: 1;\n}\n";

var styles$1 = ":host {\n  display: block;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border: 0.0625em solid #efefef;\n  border-radius: 0.25em;\n}\n\n#focusOut {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 100%;\n}\n\n#focusOut ::slotted(*) {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n  border: none;\n  border-radius: inherit;\n  padding: 0.5625em;\n}\n\n#focusOut ::slotted([slot='icon']) {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n  padding: 0.75em;\n}\n\n:host(.is-disabled) {\n  background: #efefef;\n}\n\n/* Safari doesn't like :empty on slot */\n:host(.upd-tile-no-icon) [name='icon'] {\n  display: none;\n}\n\n:host(.upd-checked),\n:host(:active) {\n  background: #f3fcff;\n}\n\n:host(.upd-invalid:active) {\n  background: #fde2e4;\n}\n\n:host(:hover) {\n  border-color: #aac7d6;\n}\n\n:host(.upd-focus) {\n  outline: none;\n  border-color: #2b7499;\n}\n\n:host(.upd-invalid) {\n  border-color: #f84e57;\n}\n\n:host(.upd-invalid.upd-focus) {\n  border-color: #ab232c;\n}\n";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CHECKED_CLASS = 'upd-checked';
var html$1 = '\n  <upd-focus-out id="focusOut">\n    <slot id="defaultSlot"></slot>\n    <slot name="icon"></slot>\n  </upd-focus-out>\n';

var Tile = function (_withHTMLComponent) {
  _inherits$1(Tile, _withHTMLComponent);

  function Tile() {
    _classCallCheck$1(this, Tile);

    var _this = _possibleConstructorReturn$1(this, (Tile.__proto__ || Object.getPrototypeOf(Tile)).call(this));

    _this._handleFocusin = function () {
      return _this.classList.add('upd-focus');
    };

    _this._handleFocusout = function () {
      return _this.classList.remove('upd-focus');
    };

    _this._handleValidation = function (_ref) {
      var target = _ref.target;

      _this._toggleClass('upd-invalid', !target.validity.valid);
    };

    _this._handleChange = function (_ref2) {
      var target = _ref2.target;

      _this._toggleClass(CHECKED_CLASS, target.checked);
    };

    _this._handleIconSlotChange = function () {
      _this._toggleClass('upd-tile-no-icon', _this._iconSlot.assignedNodes().length === 0);
    };

    _this._handleDefaultSlotChange = function () {
      // Need the setTimeout for upd-radio-options to get the initial styling
      setTimeout(function () {
        _this._toggleClass(CHECKED_CLASS, _this._defaultSlot.assignedNodes().some(function (node) {
          return node.checked;
        }));
      });
    };

    _this._focusOut = _this.shadowRoot.querySelector('#focusOut');
    _this._defaultSlot = _this.shadowRoot.querySelector('#defaultSlot');
    _this._iconSlot = _this.shadowRoot.querySelector('slot[name="icon"]');
    _this._defaultSlotObserver = new MutationObserver(_this._handleDefaultSlotChange);
    return _this;
  }

  _createClass(Tile, [{
    key: 'connected',
    value: function connected() {
      this.addEventListener('change', this._handleChange);
      this.addEventListener('updvalidation', this._handleValidation);
      this._focusOut.addEventListener('focusin', this._handleFocusin);
      this._focusOut.addEventListener('updfocusout', this._handleFocusout);
      this._defaultSlot.addEventListener('slotchange', this._handleDefaultSlotChange);
      this._iconSlot.addEventListener('slotchange', this._handleIconSlotChange);

      this._defaultSlotObserver.observe(this.shadowRoot, {
        attributes: true,
        subtree: true
      });

      this._handleIconSlotChange();
    }
  }, {
    key: 'disconnected',
    value: function disconnected() {
      this.removeEventListener('change', this._handleChange);
      this.removeEventListener('updvalidation', this._handleValidation);
      this._focusOut.removeEventListener('focusin', this._handleFocusin);
      this._focusOut.removeEventListener('updfocusout', this._handleFocusout);
      this._defaultSlot.removeEventListener('slotchange', this._handleDefaultSlotChange);
      this._iconSlot.removeEventListener('slotchange', this._handleIconSlotChange);
      this._defaultSlotObserver.disconnect();
    }

    // Hack since Safari doesn't work with slot:empty

  }, {
    key: '_toggleClass',
    value: function _toggleClass(className, value) {
      // IE11 doesn't support classList.toggle 2nd argument
      Boolean(value) ? this.classList.add(className) : this.classList.remove(className);
    }
  }]);

  return Tile;
}(withHTMLComponent(styles$1, html$1)());

customElements.define('upd-tile', Tile);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var html = '<slot></slot>';

var Tiles = function (_withHTMLComponent) {
  _inherits(Tiles, _withHTMLComponent);

  function Tiles() {
    _classCallCheck(this, Tiles);

    return _possibleConstructorReturn(this, (Tiles.__proto__ || Object.getPrototypeOf(Tiles)).apply(this, arguments));
  }

  return Tiles;
}(withHTMLComponent(styles, html)());

customElements.define('upd-tiles', Tiles);
